import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _excluded = ["backgroundImageURL"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

import React from 'react';
import styled, { up, css, x } from '@xstyled/styled-components';
import { ScreenContainer } from './ScreenContainer';
export var HeroTitle = styled.h1Box(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  font-size: 38;\n  font-weight: 600;\n  line-height: 1.2;\n  letter-spacing: -1.12px;\n  margin: 0 0 2;\n\n  ", "\n\n  ", "\n"])), up('md', css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      padding-top: 4;\n      font-size: 48;\n    "])))), up('xl', css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      font-size: 60;\n    "])))));
export var HeroTeaser = styled.pBox(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  font-size: 18;\n  margin: 3 0;\n\n  ", "\n\n  ", "\n"])), up('md', css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      font-size: 20;\n    "])))), up('xl', css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      font-size: 24;\n    "])))));
var InnerHero = styled(ScreenContainer)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  background-repeat: no-repeat;\n  background-position: top -5% center;\n  background-size: 100% auto;\n  padding-top: 65%;\n  text-align: center;\n\n  ", "\n\n  ", "\n"])), up('md', css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      padding-top: 0;\n      margin-top: 5;\n      background-position: center right;\n      background-size: 58% auto;\n      min-height: 400;\n      text-align: left;\n    "])))), up('xl', css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n      margin-top: 6;\n    "])))));
export var Hero = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var backgroundImageURL = _ref.backgroundImageURL,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(InnerHero, Object.assign({
    ref: ref,
    backgroundImage: "url(" + backgroundImageURL + ")"
  }, props));
});
export var HeroBody = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(x.div, Object.assign({
    ref: ref,
    w: {
      md: 0.5
    }
  }, props));
});
export var HeroSection = styled.sectionBox(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  padding-top: 2;\n  padding-bottom: 5;\n"])));
export var HeroActionList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(x.div, Object.assign({
    ref: ref,
    row: true,
    m: -2,
    justifyContent: {
      xs: 'center',
      md: 'initial'
    }
  }, props));
});
export var HeroAction = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(x.div, Object.assign({
    ref: ref,
    col: "auto",
    p: 2
  }, props));
});